import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const DatasourceLineageCountsFragmentGql: DocumentNode = gql`
fragment DatasourceLineageCountsFragment on PublishedDatasource {
  unfilteredFieldsConnection: fieldsConnection(filter: { isHidden: false }) {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
`;
